import React from "react";

/*
 * Assinatura "FLAMEX · ÁREA COMERCIAL" enviada pelo dono em 2026-09-16 (arquivo do Illustrator),
 * com os ajustes pedidos na sequência: letras do FLAMEX em preto (eram vermelhas) e o
 * "ÁREA COMERCIAL" como etiqueta amarela com o texto VAZADO — o recorte deixa passar o fundo do
 * painel, então a "cor" do texto é sempre a do fundo, sem precisar repetir o tom em lugar nenhum.
 *
 * Três mudanças em relação ao arquivo original, todas necessárias fora do Illustrator:
 *
 * 1. viewBox recortado (era 0 0 1080 1080, com a arte só no meio): renderizada inteira, a logo
 *    ficaria pequena no meio de uma área transparente.
 * 2. O "ÁREA COMERCIAL" era texto em Myriad Pro, fonte que ninguém tem instalada — sairia numa
 *    substituta, de largura imprevisível. Aqui usa a Montserrat que o login já carrega.
 * 3. Os dois traços laterais viraram a etiqueta.
 *
 * Por isso o SVG vive embutido, e não em public/: como <img> ele fica isolado e não enxerga as
 * fontes da página.
 */
export default function FlamexAreaComercialLogo({ className = "" }) {
  return (
    <svg
      className={className}
      viewBox="120 290 860 500"
      role="img"
      aria-label="Flamex — Área Comercial"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Letras: currentColor, definido no CSS do login (--paper-ink). */}
      <g fill="currentColor">
        <path d="M151.4,646.66s18.18,2.73,27.27-9.09c9.09-11.82,12.73-54.54,12.73-54.54h53.63l3.64-20.91h-52.72l6.36-31.82h72.72l3.64-20.91h-82.72s-14.54.91-20,16.36c-5.45,15.45-22.73,117.26-24.54,120.9Z" />
        <path d="M290.48,509.4l25.45.91-22.73,115.45h67.27l-3.64,20.91h-74.54s-17.27,0-15.45-17.27c1.82-17.27,23.63-119.99,23.63-119.99Z" />
        <polygon points="510.47 646.66 565.92 510.31 580.46 510.31 595 597.57 644.09 510.31 659.54 510.31 663.18 646.66 637.73 646.66 635.91 573.03 591.37 646.66 581.37 646.66 566.82 572.12 535.92 646.66 510.47 646.66" />
        <path d="M703.18,510.31h94.54l-3.64,20.91-69.09-.91-5.45,32.72h49.09l-3.64,20h-50l-8.18,41.81,67.27.91-4.55,20.91-77.27-.91s-15.45.91-12.73-20c2.73-20.91,23.63-115.45,23.63-115.45Z" />
        <path d="M811.35,511.22l28.18,62.72-59.09,72.72h30l40-48.18s15.45,33.63,22.73,40.91c7.27,7.27,30,7.27,30,7.27l-34.54-69.09,60-67.27-30.91-.91-40.91,46.36s-7.27-29.09-21.82-41.81c0,0-5.45-5.45-20.91-4.55,0,0-3.64,0-2.73,1.82Z" />
        <path d="M470.47,508.49h-10l-89.99,138.17h27.27l18.18-28.18h52.72l4.55,28.18h27.27l-30-138.17ZM426.38,600.75l30.91-50.9,8.18,50.9h-39.09Z" />
      </g>

      {/* Chama: o amarelo da marca, como no arquivo original. */}
      <path
        fill="#f8b114"
        d="M333.66,568.94l35.97-163.95c4.1-18.7,12.72-36.2,25.52-50.44,10.65-11.84,25.39-22.98,44.86-26.92,1.64-.33,3.26-.73,4.87-1.2,4.97-1.47,18.87-4.75,44.23-4.75h220.89s-24.09,37.72-46.81,51.36c-22.73,13.64-35.45,16.36-96.36,15.45-52.24-.78-85.09-.89-93.37-.91-2.46,0-4.91.37-7.22,1.22-3.22,1.19-7.03,3.48-8.49,7.87-2.73,8.18-4.55,17.27-4.55,17.27h162.71s-19.48,38.12-44.55,51.39c-1.4.74-2.77,1.51-4.12,2.34-2.3,1.41-7.93,4.14-20.41,7.17-16.82,4.09-77,1.73-97.82,1.8-6.49.02-12.89,1.74-18.37,5.21-3.91,2.48-8.01,6.06-11.07,11.17-8.18,13.64-30,45.45-30,45.45,0,0-14.72,22.94-37.27,29.09-20,5.45-18.63,1.36-18.63,1.36Z"
      />

      {/* Etiqueta da largura exata do "FLAMEX" (x 151→951), ancorada de ponta a ponta.
          Texto PRETO, não vazado: o vazado tinha 1,7:1 contra o amarelo e dependia do formato da letra
          para ser lido. Em preto são ~9:1, e fecha o conjunto com o "FLAMEX" preto. */}
      <rect x="151" y="690" width="800" height="86" rx="14" fill="#f8b114" />
      <text
        x="551"
        y="733"
        textAnchor="middle"
        dominantBaseline="central"
        fill="currentColor"
        fontFamily="Montserrat, sans-serif"
        fontSize="52"
        fontWeight="800"
        letterSpacing="6"
      >
        ÁREA COMERCIAL
      </text>
    </svg>
  );
}
